import getContent from '../lib/dictionaryFetcher';
import {
  linkToProductMapping,
  linkToExtraProductMapping,
  optionsMapping,
  productsToIconMapping,
  quizOptionsCountryFilter
} from './quizStaticMapping';
import { MISC } from './constants';
import { get } from 'lodash';

const quizCardSteps = (stepNumber, app) => {
  let optionsStepArr = [],
    userCountry = get(app, 'context.locale.country', '');
  optionsMapping[stepNumber].forEach(option => {
    const optionCountryFilter = get(quizOptionsCountryFilter, `${option}`, []);
    if (!optionCountryFilter.includes(userCountry)) {
      optionsStepArr.push({
        title: getContent('quiz', `${stepNumber}.${option}`),
        value: option,
        icon: `${MISC.PAYPAL_IMAGES_LOC}/quiz/${option}.svg`
      });
    }
  });
  let subtitle =
    stepNumber === 'step2'
      ? getContent('quiz', `${stepNumber}.subtitle`, '', {
          params: { appcenter: '/merchantapps/appcenter' }
        })
      : getContent('quiz', `${stepNumber}.subtitle`);
  return {
    multi: stepNumber !== 'step4',
    square: stepNumber === 'step1' || stepNumber === 'step3',
    title: getContent('quiz', `${stepNumber}.title`),
    subtitle,
    options: optionsStepArr
  };
};

const quizResultProducts = product => {
  return {
    header: getContent('quiz', `results.${product}.heading`),
    subText: getContent('quiz', `results.${product}.subtext`),
    icon: `${MISC.PAYPAL_IMAGES_LOC}/${productsToIconMapping[product]}.svg`,
    link: linkToProductMapping[product]
  };
};

const quizResultExtra = extra => {
  return {
    header: getContent('quiz', `results.extra.${extra}.title`),
    subtext: getContent('quiz', `results.extra.${extra}.subText`),
    linkText: getContent('quiz', `results.extra.${extra}.link`),
    link: linkToExtraProductMapping[extra],
    icon: `${MISC.PAYPAL_IMAGES_LOC}/quiz/${extra}.svg`
  };
};

export { quizCardSteps, quizResultProducts, quizResultExtra };
